import React from "react";

export const ProgrammingBrowserSearchIcon: React.FC<React.ComponentProps<"svg">> = ({
  vectorEffect,
  ...rest
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="programming-browser-search--search-window-glass-app-code-programming-query-find-magnifying-apps--Streamline-Core">
        <g id="Group">
          <path
            id="Vector"
            d="M7.28557 15.2857H2.71415C2.41104 15.2857 2.12035 15.1653 1.90602 14.951C1.6917 14.7366 1.57129 14.4459 1.57129 14.1428V2.71427C1.57129 2.41116 1.6917 2.12047 1.90602 1.90615C2.12035 1.69182 2.41104 1.57141 2.71415 1.57141H15.2856C15.5887 1.57141 15.8794 1.69182 16.0937 1.90615C16.308 2.12047 16.4284 2.41116 16.4284 2.71427V8.42855"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M1.57129 5H16.4284"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_3"
            d="M11.8571 14.7143C13.4351 14.7143 14.7143 13.4351 14.7143 11.8571C14.7143 10.2792 13.4351 9 11.8571 9C10.2792 9 9 10.2792 9 11.8571C9 13.4351 10.2792 14.7143 11.8571 14.7143Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_4"
            d="M13.8799 13.88L16.4285 16.4286"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
      </g>
    </svg>
  );
};
